<template>
  <div :class="['wrapper', classes]">

    <single-modal @API="FatherDetailModal = $event" :title="fatherDetailModalConfigs.title" :options="fatherDetailModalConfigs">
      <form class="form-horizontal" role="form">
        <div v-if="!emptyDetailData.typ" class="form-detail-field form-group">
          <input-w :configs="fatherModalInputConfigs.type">
            <label class="col-sm-3 control-label">{{fatherModalInputConfigs.type.val}}</label>
            <div class="col-sm-4"><input type="text" class="form-detail form-control" :value="fatherModalInputConfigs.type.cod" readonly/></div>
          </input-w>
        </div>
        <div v-if="!emptyDetailData.des" class="form-detail-field form-group">
          <input-w :configs="fatherModalInputConfigs.description">
            <label class="col-sm-3 control-label">{{fatherModalInputConfigs.description.lbl}}</label>
            <div class="col-sm-8"><textarea id="des_area" :rows="fatherModalInputConfigs.description.rows" style="resize: none;" class="form-detail form-control" :value="fatherModalInputConfigs.description.val" readonly/></div>
          </input-w>
        </div>
        <cfg cid="modalDetail.feature_area" tag='div'>
          <div v-if="!emptyDetailData.spe" class="form-detail-field form-group">
            <input-w :configs="fatherModalInputConfigs.feature">
              <label class="col-sm-3 control-label">{{fatherModalInputConfigs.feature.lbl}}</label>
              <div class="col-sm-8"><textarea id="feature_area" :rows="fatherModalInputConfigs.feature.rows" style="resize: none;" class="form-detail form-control" :value="fatherModalInputConfigs.feature.val" readonly/></div>
            </input-w>
          </div>
        </cfg>
        <div v-if="!emptyDetailData.pos" class="form-detail-field form-group">
          <input-w :configs="fatherModalInputConfigs.position">
            <label class="col-sm-3 control-label">{{fatherModalInputConfigs.position.lbl}}</label> 
            <div class="col-sm-3"><input type="text" class="form-detail form-control" :value="fatherModalInputConfigs.position.val" readonly/></div>
          </input-w>
        </div>
        <div v-if="!emptyDetailData.qty" class="form-detail-field form-group">
          <input-w :configs="fatherModalInputConfigs.quantity">
            <label class="col-sm-3 control-label">{{fatherModalInputConfigs.quantity.lbl}}</label>
            <div class="col-sm-3"><input type="text" class="form-detail form-control" :value="fatherModalInputConfigs.quantity.val" readonly/></div>
          </input-w>
        </div>
        <div v-if="!emptyDetailData.spi" class="form-detail-field form-group">
          <input-w :configs="fatherModalInputConfigs.codSost">
            <label class="col-sm-3 control-label">{{fatherModalInputConfigs.codSost.lbl}}</label>
            <div class="col-sm-8"><input type="text" class="form-detail form-control" :value="fatherModalInputConfigs.codSost.val" readonly/></div>
          </input-w>
        </div>
        <div v-if="!emptyDetailData.not" class="form-detail-field form-group">
          <input-w :configs="fatherModalInputConfigs.not">
            <label class="col-sm-3 control-label">{{fatherModalInputConfigs.not.lbl}}</label>
            <div class="col-sm-8"><textarea id="notes_area" :rows="fatherModalInputConfigs.not.rows" style="resize: none;" class="form-detail form-control" :value="fatherModalInputConfigs.not.val" readonly/>
            </div>
          </input-w>
        </div>
        <div v-if="!emptyDetailData.val" class="form-detail-field form-group">
          <label class="col-sm-3 control-label">{{fatherModalInputConfigs.validity.lbl}}</label>
          <div class="col-sm-8"><grid :columns="valListCfg.columns" :source.sync="valList" :options="valGridOptions" 
              :lang="$root.token.idLingua" :name="valListCfg.title" :selectParameter="$Behaviors.focusBy()" 
              :select="focus"></grid>
          </div>
        </div>
        <div v-if="!emptyDetailData.doc" class="form-detail-field form-group">
          <label class="col-sm-3 control-label">{{fatherModalInputConfigs.documents.lbl}}</label>
          <div class="col-sm-8"><grid :columns="docListCfg.columns" :source.sync="docList" :options="valGridOptions" 
              :lang="$root.token.idLingua" :name="docListCfg.title" :selectParameter="$Behaviors.focusBy()" 
              :select="focus"></grid>
          </div>
        </div>
        <div v-if="!emptyDetailData.attr" class="form-detail-field form-group">
          <label class="col-sm-3 control-label">{{fatherModalInputConfigs.attributes.lbl}}</label>
          <div class="col-sm-8"><grid :columns="attrListCfg.columns" :source.sync="attrList" :options="attrGridOptions" 
              :lang="$root.token.idLingua" :name="attrListCfg.title" :selectParameter="$Behaviors.focusBy()" 
              :select="focus"></grid>
          </div>
        </div>
      </form>
    </single-modal>

    <tab-modal @API="UserTabModal = $event" :tabs="modalTabs" :start="start" :options="userDataModalConfigs" :closeModal="saveChanges">
      <div slot="generalData" class="user-modal-data tab-general">
        <div class="modal-body">
          <form class="form-horizontal" role="form">
            <div class="form-group">
              <input-w :configs="userInputConfigs.username">
                <label class="col-sm-2 control-label" for="userField">{{userInputConfigs.username.lbl}}</label>
                <div class="col-sm-4 input-group"><input id="userField" type="text" class="form-control" readonly :value="userInputConfigs.username.val"/><!--<span id="editField" class="input-group-addon"><div id="editField" :class="$root.icons.edit" style="cursor: pointer;" @click="enableEdit('userField')"></div></span>--></div>
              </input-w>
            </div>
            <div class="form-group">
              <input-w :configs="userInputConfigs.fullname">
                <label class="col-sm-2 control-label" for="namField">{{userInputConfigs.fullname.lbl}}</label>
                <div class="col-sm-4 input-group"><input id="namField" type="text" class="form-control" readonly :value="userInputConfigs.fullname.val"/><!--<span id="editField" class="input-group-addon"><div id="editField" :class="$root.icons.edit" style="cursor: pointer;" @click="enableEdit('namField')"></div></span>--></div>
                <!--<label class="col-sm-3 control-label" for="namField" 
                  style="cursor: pointer; padding-left: 0px; padding-right: 40px;"
                  @click="ChangePwdModal.open()">
                  <a>{{$Jed.firstUpperTranslate('change password')}}</a>
                </label>-->
              </input-w>
            </div>
            <div class="form-group">
              <input-w :configs="userInputConfigs.nomeGruppo">
                <label class="col-sm-2 control-label" for="profileField">{{userInputConfigs.nomeGruppo.lbl}}</label>
                <div class="col-sm-4 input-group"><input type="text" class="form-control" readonly :value="userInputConfigs.nomeGruppo.val"/></div>
              </input-w>
            </div>
            <div class="form-group">
              <input-w :configs="userInputConfigs.lang">
                <label class="col-sm-2 control-label" for="langField">{{userInputConfigs.lang.lbl}}</label>
                <div class="col-sm-2 input-group">
                  <input type="text" class="form-control" readonly :value="userInputConfigs.lang.val"/>
                  <img style="position: absolute; padding: 6px;" :src="langFlag"/>
                </div>
              </input-w>
            </div>
            <div class="form-group">
              <input-w :configs="userInputConfigs.mail">
                <label class="col-sm-2 control-label" for="mailField">{{userInputConfigs.mail.lbl}}</label>
                <div class="col-sm-8 input-group"><input id="mailField" type="text" class="form-control" readonly :value="userInputConfigs.mail.val"/><!--<span id="editField" class="input-group-addon"><div id="editField" :class="$root.icons.edit" style="cursor: pointer;" @click="enableEdit('mailField')"></div></span>--></div>
              </input-w>
            </div>
            <div class="form-group">
              <input-w :configs="userInputConfigs.phone">
                <label class="col-sm-2 control-label" for="phoneField">{{userInputConfigs.phone.lbl}}</label>
                <div class="col-sm-4 input-group"><input id="phoneField" type="text" class="form-control" readonly :value="userInputConfigs.phone.val"/><!--<span id="editField" class="input-group-addon"><div id="editField" :class="$root.icons.edit" style="cursor: pointer;" @click="enableEdit('phoneField')"></div></span>--></div>
              </input-w>
            </div>
          </form>
        </div>
      </div>
      <div slot="clientData" class="user-modal-data">
        <div class="modal-body">
          <form class="form-horizontal" role="form">
            <div v-if="$Behaviors.showClientLogo" class="form-group">
              <label class="col-sm-3 control-label" for="logo">{{$Jed.firstUpperTranslate('client logo')}}</label>
              <div class="col-sm-2" style="width: 100px; ">
                <img :src="logoSrc" style="width:100%;"/>
              </div>
              <label class="col-sm-3 control-label" 
                    style="cursor: pointer; padding-left: 0px; padding-right: 40px;"
                    @click="ChangeLogoModal.open()">  <!--for="userField"-->
                    <a>{{$Jed.firstUpperTranslate('change logo')}}</a>
              </label>
              <label class="col-sm-3 control-label"
                    style="cursor: pointer; padding-left: 0px; padding-right: 40px;"
                    @click="RemoveLogoModal.open()">  <!--for="userField"-->
                    <a>{{$Jed.firstUpperTranslate('remove logo')}}</a>
              </label>
            </div>
            <!--<div class="twoColForm">-->
              <div v-if="!emptyUserData.ragSoc" class="form-group">
                <input-w :configs="userInputConfigs.ragSoc">
                  <label class="col-sm-3 control-label" for="ragsoc">{{userInputConfigs.ragSoc.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.ragSoc.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.codfis" class="form-group">
                <input-w :configs="userInputConfigs.codfis">
                  <label class="col-sm-3 control-label" for="codf">{{userInputConfigs.codfis.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.codfis.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.piva" class="form-group">
                <input-w :configs="userInputConfigs.piva">
                  <label class="col-sm-3 control-label" for="pIva">{{userInputConfigs.piva.lbl}}</label>
                  <div class="col-sm-6"><input type="text" class="form-control" readonly :value='userInputConfigs.piva.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.sito" class="form-group">
                <input-w :configs="userInputConfigs.sito">
                  <label class="col-sm-3 control-label" for="sito">{{userInputConfigs.sito.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.sito.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.nomeTit" class="form-group">
                <input-w :configs="userInputConfigs.nomeTit">
                  <label class="col-sm-3 control-label" for="nomeTit">{{userInputConfigs.nomeTit.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.nomeTit.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.contCli" class="form-group">
                <input-w :configs="userInputConfigs.contCli">
                  <label class="col-sm-3 control-label" for="contact">{{userInputConfigs.contCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.contCli.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.indCli" class="form-group">
                <input-w :configs="userInputConfigs.indCli">
                  <label class="col-sm-3 control-label" for="address">{{userInputConfigs.indCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.indCli.val'/></div>
                </input-w>
              </div>
            <!--</div>-->
            <!--<div class="twoColForm">-->
              <div v-if="!emptyUserData.capCli" class="form-group">
                <input-w :configs="userInputConfigs.capCli">
                  <label  class="col-sm-3 control-label" for="cap">{{userInputConfigs.capCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.capCli.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.provCli" class="form-group">
                <input-w :configs="userInputConfigs.provCli">
                  <label class="col-sm-3 control-label" for="prov">{{userInputConfigs.provCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.provCli.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.locCli" class="form-group">
                <input-w :configs="userInputConfigs.locCli">
                  <label class="col-sm-3 control-label" for="loc">{{userInputConfigs.locCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.locCli.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.nazCli" class="form-group">
                <input-w :configs="userInputConfigs.nazCli">
                  <label class="col-sm-3 control-label" for="country">{{userInputConfigs.nazCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.nazCli.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.telCli" class="form-group">
                <input-w :configs="userInputConfigs.telCli">
                  <label class="col-sm-3 control-label" for="tel">{{userInputConfigs.telCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.telCli.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.faxCli" class="form-group">
                <input-w :configs="userInputConfigs.faxCli">
                  <label class="col-sm-3 control-label" for="fax">{{userInputConfigs.faxCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.faxCli.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.cellCli" class="form-group">
                <input-w :configs="userInputConfigs.cellCli">
                  <label class="col-sm-3 control-label" for="cell">{{userInputConfigs.cellCli.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.cellCli.val'/></div>
                </input-w>
              </div>
              <div v-if="!emptyUserData.emailServ" class="form-group">
                <input-w :configs="userInputConfigs.emailServ">
                  <label class="col-sm-3 control-label" for="cliMail">{{userInputConfigs.emailServ.lbl}}</label>
                  <div class="col-sm-8"><input type="text" class="form-control" readonly :value='userInputConfigs.emailServ.val'/></div>
                </input-w>
              </div>
            <!--</div>-->  
          </form>
        </div>
      </div>
    </tab-modal>

    <single-modal @API="ChangePwdModal = $event" ref="ChangePwdModal" :title="$Jed.firstUpperTranslate('change password')" :options="changePwdModalConfigs" class="pwd-modal">
      <form class="form-horizontal modal-input" role="form">
          <div class="form-group">
            <input-w :configs="pwdInputConfigs.cur">
              <label class="col-sm-4 control-label" for="curPwd">{{pwdInputConfigs.cur.lbl}}</label>
              <div class="col-sm-6"><input type="password" autocomplete="off" class="form-control" v-model="currentPassword"/></div>
            </input-w>
          </div>
          <div v-if="!existing" class="form-group" id="existing">
            <div class="col-sm-4"></div>
            <div class="col-sm-6" style="color: red;">La password non è corretta. Riprova.</div>
          </div>
          <div class="form-group">
            <input-w :configs="pwdInputConfigs.new">
              <label class="col-sm-4 control-label" for="newPwd">{{pwdInputConfigs.new.lbl}}</label>
              <div class="col-sm-6"><input type="password" autocomplete="off" class="form-control" v-model="newPassword"/></div> 
              <i v-if="!matching" :class="$root.icons.exclamation" style="color: red;"></i>
            </input-w>
          </div>
          <div class="form-group">
            <input-w :configs="pwdInputConfigs.ok">
              <label class="col-sm-4 control-label" for="okNewPwd">{{pwdInputConfigs.ok.lbl}}</label>
              <div class="col-sm-6"><input type="password" autocomplete="off" class="form-control" v-model="confirmNewPassword"/></div>
              <i v-if="!matching" :class="$root.icons.exclamation" style="color: red;"></i>
            </input-w>
          </div>
          <div v-if="!matching" class="form-group" id="matching">
            <div class="col-sm-4"></div>
            <div class="col-sm-6" style="color: red;">Le password non corrispondono. Riprova.</div>
          </div>
        </form>
    </single-modal>

    <single-modal @API="ChangeLogoModal = $event" :title="$Jed.firstUpperTranslate('change logo')" :options="changeLogoModalConfigs">
        <form class="form-horizontal" role="form">
          <div class="form-group modal-input">
              <input-w>
                <input type="file" class="form-control-file" aria-describedby="fileHelp"/>
              </input-w>
          </div>
        </form>
    </single-modal>

    <single-modal @API="RemoveLogoModal = $event" :title="$Jed.firstUpperTranslate('remove logo')" :options="removeLogoModalConfigs">
          <div class="modal-input">
              <label>{{$Jed.firstUpperTranslate('do you really want to remove the logo?')}}</label>
          </div>
    </single-modal>

    <single-modal @API="DoLogoutModal = $event" :title="$Jed.firstUpperTranslate('logout')" :options="doLogoutModalConfigs">
          <div class="modal-input">
              <label>{{$Jed.firstUpperTranslate('do you really want to log out?')}}</label>
          </div>
    </single-modal>

    <header class="main-header">
      <dynIcon 
        :configs="{ID: 'open_catalog', visible: true}"
        :icnClasses="['toolbar', this.$root.icons.book + ($root.help ? ' help' : '') + (active == 'open_catalog' ? ' active' : '') + ($root.BLOCK_NAVIGATION ? ' disable' : '')]"
        :styleObj="{'color': 'rgb(173, 178, 180)', 'padding': '10px 7.5px', 'margin-left': '0px', 'display':'block', 'float':'left', 'cursor': 'pointer'}" 
        :exec="hoverTooltipEnabled ? showContent : (!$root.help ? showContent : $root.trigger_help)"
        :execParam="hoverTooltipEnabled ? ['open_catalog',null,null,'pickIndex'] : !$root.help ? ['open_catalog',null,null,'pickIndex'] : ['open_catalog']"
        :hoverParam="'open_catalog'">
      </dynIcon>

      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top resize-reset table-resize-reset navbar-color" :class="[right ? 'side-right' : 'side-left']" role="navigation">
          
        <span> 
          <a id="goto_brandsite" href="/" @click.prevent="!$root.help ? goToBrandSite() : $root.trigger_help('goto_brandsite')">
            <div id="logo_div" class="img-responsive center-block logo resize-reset table-resize-reset logo-wrapper"
                style="padding: 0px; width: auto; height: 55px;">
              <img style="max-height: 100%;" :src="logoSrc">
            </div>
          </a>
        </span>
              
        <breadcrumb :configs="{visible: true, full_path: true, nodes_shown: breadcrumb_nodes}"
          ulClasses="top-breadcrumb"
          :ulStyle="{'border-radius': '0px', margin: '0px','text-align': 'left'}"
          :liStyle="{color: 'white'}">
        </breadcrumb>

        <span style="position: absolute; bottom: 10px; right: 0px;">
          <popover-alert v-if="$Behaviors.showHelpModeIcon && this.sessionStorage.getItem('device') == 'desktop' " effect="fade" placement="left" :title="$Jed.firstUpperTranslate('help mode', null)"
            :content="$Jed.firstUpperTranslate('you activated %1$s, click on a command to view his purpose', null, {key: 'help mode'})" 
            :no="toggleHelpFlag" :popoverCondition="$root.help == true" :showOK='false' :no_text="$Jed.firstUpperTranslate('cancel')"
            :popoverStyle="{top:'10px', 'max-width': '200px', width: '200px', 'font-size': 'small', height: 'max-content'}" 
            :arrowStyle="{top:'12%'}" :textStyle="{color: '#222'}" classes=""> 
                <dynIcon
                  :configs="{ID: 'noOverlay', visible: true}" 
                  :icnClasses="[this.$root.icons.help + (active == 'toggle_help_flag' ? ' active' : ''), 'navbar-icon-right']" 
                  :exec="toggleHelpFlag"
                  :hoverParam="'notification'"> <!--:styleObj="{'margin-right': $root.token.categoriaCliente=='Distributore' ? '185px' : '150px'}"-->
                </dynIcon> 
          </popover-alert>

          <popover-alert effect="fade" placement="left" :title="$Jed.firstUpperTranslate('notification list', null)"
            :ok="toggleNotification" :popoverCondition="showNotifications == true" :showOK='false' :showNO="false"
            :popoverStyle="{top:'10px', 'max-width': '350px', width: '350px', 'font-size': 'small', height: 'max-content'}" 
            :arrowStyle="{top:'12%'}" :textStyle="{color: '#222'}" classes=""> 
                <dynIcon 
                  :configs="{ID: 'notification', visible: true}" 
                  :exec="hoverTooltipEnabled ? toggleNotification : !$root.help ? toggleNotification : $root.trigger_help"
                  :execParam="['notification']"
                  :hoverParam="'notification'"
                  :icnClasses="['navbar-icon-right',$root.icons.message]" 
                  :count="notifCount"> <!--:styleObj="{'margin-right': notifIcon}"-->
                </dynIcon>

                <template slot="content">
                    <pending-notifications></pending-notifications>
                </template>
          </popover-alert>

          <dynIcon v-if="$Behaviors.showUserManualIcon"
            :configs="{ID: 'show_user_manual', visible: true}"  
            :exec="hoverTooltipEnabled ? showUserManual : !$root.help ? showUserManual : $root.trigger_help" 
            :execParam="['show_user_manual']"
            :hoverParam="'show_user_manual'" 
            :icnClasses="['navbar-icon-right',$root.icons.user_manual]"  
            > <!--:styleObj="{'margin-right': '80px'}"-->
          </dynIcon> 

          <dynIcon v-if="$root.token.categoriaCliente=='Distributore' && !$Components['goto_distrib'].hidden" 
            :configs="{ID: 'goto_distrib', visible: true}"  
            :exec="hoverTooltipEnabled ? goToDistrib : !$root.help ? goToDistrib : $root.trigger_help"
            :hoverParam="'goto_distrib'" 
            :icnClasses="['navbar-icon-right',$root.icons.userAgent]"  
            > <!--:styleObj="{'margin-right': '115px'}"-->
          </dynIcon> 
          <dynIcon 
            :configs="{ID: 'show_user_data', visible: true}"  
            :exec="hoverTooltipEnabled ? showUserData : !$root.help ? showUserData : $root.trigger_help" 
            :execParam="['show_user_data']"
            :hoverParam="'show_user_data'" 
            :icnClasses="['navbar-icon-right',$root.icons.user]"  
            > <!--:styleObj="{'margin-right': '80px'}"-->
          </dynIcon> 
          <dynIcon 
            :configs="{ID: 'toggle_fullscreen', visible: true}"  
            :exec="hoverTooltipEnabled ? toggleFullScreen : !$root.help ? toggleFullScreen : $root.trigger_help" 
            :execParam="['toggle_fullscreen']" 
            :hoverParam="'toggle_fullscreen'"
            :icnClasses="['navbar-icon-right',fullscreen]"  
            > <!--:styleObj="{'margin-right': '45px'}"-->
          </dynIcon> 
          <dynIcon 
            :configs="{ID: 'logout', visible: true}"  
            :exec="hoverTooltipEnabled ? doLogoutModal : !$root.help ? doLogoutModal : $root.trigger_help" 
            :execParam="['logout']" 
            :hoverParam="'logout'"
            :icnClasses="['navbar-icon-right', $root.icons.logout, $root.help ? ' help' : '']"  
            :styleObj="{'margin-right': '10px'}"> 
          </dynIcon>
        </span>
      </nav> 
    
    </header>

    <!-- SPOSTATO BTN LAYOUT CONTAINER in NODE WRAPPER -->

    <!-- Left side column. contains the logo and sidebar  :ok="backward"-->
    <sidebar :right="right" /> 
    
    <aside id="side-shadow" class="table-resize-reset resize-stop sup-resize-stop" 
      :class="[right ? 'pull-right control-sidebar wtree_right maintree wtree_fake_right right_fix' : 'main-sidebar pull-left wtree_left wtree_fake_left ']"
      style="z-index: -1; background-color: rgba(255,255,255,0.3); border: 1px ridge #999; margin-top:55px;">
    </aside>

    <aside id="side-toolbar" class="table-resize-reset resize-stop sup-resize-stop sidebar-left main-sidebar pull-left toolbar" 
      style="width: 50px; padding-top: 10px; margin-top: 50px; text-align: center;">

      <cfg cid="toolbar.catalog_icon" tag='i'>
        <dynIcon 
          :configs="{ID: 'show_catalog_tree', visible: true}"  
          :exec="hoverTooltipEnabled ? showContent : !$root.help ? showContent : $root.trigger_help" 
          :execParam="hoverTooltipEnabled ? ['show_catalog_tree', mainSidebarOpened ? 'close' : 'open', null, 'openSidebarMenu'] : !$root.help ? ['show_catalog_tree', mainSidebarOpened ? 'close' : 'open', null, 'openSidebarMenu'] : ['show_catalog_tree']" 
          :hoverParam="'show_catalog_tree'"
          :icnClasses="[$root.help ? ' help' : '', $root.icons.tree, active == 'show_catalog_tree' ? ' active' : '', $root.BLOCK_NAVIGATION ? ' disable' : '']"  
          :styleObj="{'color': '#ecf0f5', 'padding': '10px 0px', 'display': 'block'}"> 
        </dynIcon>   
      </cfg>  
      <cfg cid="toolbar.search_icon" tag='i'>
        <dynIcon 
          :configs="{ID: 'show_search', visible: true}"  
          :exec="hoverTooltipEnabled ? showContent : !$root.help ? showContent : $root.trigger_help" 
          :execParam="hoverTooltipEnabled ? ['show_search', mainSidebarOpened ? 'close' : 'open', null, 'openSearchMenu'] : !$root.help ? ['show_search', mainSidebarOpened ? 'close' : 'open', null, 'openSearchMenu'] : ['show_search']" 
          :hoverParam="'show_search'"
          :icnClasses="[$root.help ? ' help' : '', $root.icons.search, active == 'show_search' ? ' active' : '', $root.BLOCK_NAVIGATION ? ' disable' : '']"  
          :styleObj="{'color': '#ecf0f5', 'padding': '10px 0px', 'display': 'block'}"> 
        </dynIcon>      
      </cfg>
      <cfg v-if="!this.$root.blockCart" cid="toolbar.cart_icon" tag='i'>
        <dynIcon v-if="!this.$Configs.ecp.ecidUrl"
          :configs="{ID: 'show_cart', visible: true}"  
          :exec="hoverTooltipEnabled ? showContent : !$root.help ? showContent : $root.trigger_help" 
          :execParam="hoverTooltipEnabled ? ['show_cart', 'close', 'ShopCart', null] : !$root.help ? ['show_cart', 'close', 'ShopCart', null] : ['show_cart']" 
          :hoverParam="'show_cart'"
          :icnClasses="[$root.help ? ' help' : '', $root.icons.cart, active == 'show_cart' ? ' active' : '', $root.BLOCK_NAVIGATION ? ' disable' : '']"  
          :styleObj="{'color': '#ecf0f5', 'padding': '10px 0px', 'display': 'block'}"
          :count="$Behaviors.quantityOnCartIcon ? cartCount : 0"> 
        </dynIcon>    
      </cfg>  
      <cfg v-if="!this.$root.ecIntegrationActive && !this.$root.blockCart" cid="toolbar.archive_icon" tag='i'>
        <dynIcon v-if="!this.$Configs.ecp.ecidUrl"
          :configs="{ID: 'show_archive', visible: true}"  
          :exec="hoverTooltipEnabled ? showContent : !$root.help ? showContent : $root.trigger_help" 
          :execParam="hoverTooltipEnabled ? ['show_archive', 'close', 'OrdersArch', null] : !$root.help ? ['show_archive', 'close', 'OrdersArch', null] : ['show_archive']" 
          :hoverParam="'show_archive'"
          :icnClasses="[$root.help ? ' help' : '', $root.icons.archive, active == 'show_archive' ? ' active' : '', $root.BLOCK_NAVIGATION ? ' disable' : '']"  
          :styleObj="{'color': '#ecf0f5', 'padding': '10px 0px', 'display': 'block'}"> 
        </dynIcon>
      </cfg>  
      <cfg cid="toolbar.preference_icon" tag='i'>
        <dynIcon v-if="$Behaviors.enablePreferences"
          :configs="{ID: 'show_preference', visible: true}"  
          :exec="hoverTooltipEnabled ? showContent : !$root.help ? showContent : $root.trigger_help" 
          :execParam="hoverTooltipEnabled ? ['show_preference', 'close', 'preferences', null] : !$root.help ? ['show_preference', 'close', 'preferences', null] : ['show_preference']" 
          :hoverParam="'show_preference'"
          :icnClasses="[$root.help ? ' help' : '', $root.icons.check_list, active == 'show_preference' ? ' active' : '', $root.BLOCK_NAVIGATION ? ' disable' : '']"  
          :styleObj="{'color': '#ecf0f5', 'padding': '10px 0px', 'display': 'block'}"> 
        </dynIcon>
      </cfg>  

      <!-- <i class="fa fa-code fa-2x" aria-hidden="true" :class="{'help': $root.help}" @click="devPage()"
      style="color: #ecf0f5; padding: 10px 0px; display:block;"></i>-->
      <cfg cid="toolbar.sync_icon" tag='i'>
        <i v-if="$root.preferences.useOffline && $root.preferences.sincro == 'Manual'" id="manual_sync" aria-hidden="true" :class="this.$root.icons.sync + ($root.help ? ' help' : '')"
        style="color: #ecf0f5; padding: 10px 0px 25px 0px; margin-left: 7px !important; display:block; position: absolute; bottom: 35px; cursor: pointer;"
        @click="!$root.help ? $root.manualSync() : $root.trigger_help('manual_sync')"></i>
      </cfg>  

      <popover-alert effect="fade" placement="right" :content="info_popup_content" :ok="toggleInfoSw" 
        :popoverCondition="info_software == true"
        :popoverStyle="{ top: 'calc(100% - 100px)', left:'50px', 'max-width': '200px', width: '200px', 'font-size': 'small', height: 'max-content'}" 
        :arrowStyle="{top:'75%'}" :showOK="true" :ok_text="$Jed.firstUpperTranslate('close')" :showNO="false" :textStyle="{color: '#222'}" >
          <dynIcon
            :configs="{ID: 'show_info_sw', visible: true}"  
            :exec="hoverTooltipEnabled ? toggleInfoSw : !$root.help ? toggleInfoSw : $root.trigger_help" 
            :execParam="['show_info_sw']" 
            :hoverParam="'show_info_sw'"
            :icnClasses="[$root.help ? ' help' : '', $root.icons.info]"  
            :styleObj="{'color': '#ecf0f5', 'padding': '10px 0px 25px 0px', 'display': 'block', 'position': 'absolute', 'bottom': '-12px', 'cursor': 'pointer'}"> 
          </dynIcon>
      </popover-alert>
    </aside>

    <!--popover con descrizione funzionamento per ogni icona in help mode-->
    <help-popover v-for="h in helpers"  :key="h.id"
      :helpProp="h.id" :reference="h.id" :msg="$Jed.firstUpperTranslate(h.msg)" 
      :offset="h.pos">
    </help-popover> 

    <support-sidebar v-if="openSupportSidebar" :right="right" :content="supportContent" @closeme="noWrapperRoute"/> 

    <aside v-if="openSupportSidebar" id="side-shadow" class="table-resize-reset resize-stop sup-resize-stop" 
      :class="[!right ? 'pull-right control-sidebar wtree_right wtree_fake_right right_fix' : 'main-sidebar pull-left wtree_left wtree_fake_left ']"
      style="z-index: -1; background-color: rgba(255,255,255,0.3); border: 1px ridge #999; margin-top:55px;">
    </aside>

    <aside v-if="showSupportSidebar" id="extra-toolbar" class="table-resize-reset resize-stop sup-resize-stop sidebar-right main-sidebar pull-right toolbar right_fix" 
      style="width: 50px; padding-top: 10px; margin-top: 55px; text-align: center; z-index: 812;">
      <!-- SUPPORT COLLAPSE 
      <i id="toggle_support" class="fa" :class="[openSupportSidebar ? $root.icons.openSidebar : $root.icons.closeSidebar]" aria-hidden="true"
      style="color: #ecf0f5; padding: 10px 0px 20px 0px; display:block; border-bottom: 1px solid #090c0f; box-shadow: rgb(80, 94, 101) 0px 1px 0px;" 
      @click="!$root.help ? handleSupportSidebar(!openSupportSidebar) : $root.trigger_help('toggle_support')"></i> -->

      <!-- NODE WRAPPER VIEWS TRIGGER-->
      <dynIcon 
        :configs="{ID: 'switch_detail', visible: true}"   
        :exec="hoverTooltipEnabled ? viewTo : !$root.help ? viewTo : $root.trigger_help"  
        :execParam="hoverTooltipEnabled ? ['Detail'] : !$root.help ? ['Detail'] : ['switch_detail']" 
        :hoverParam="'switch_detail'"  
        :icnClasses="[activeView == 'Detail' ? ' active-view' : '', $root.icons.detail, 'support-tool-icon']">  
      </dynIcon> 
   
      <dynIcon 
        :configs="{ID: 'switch_table', visible: true}"   
        :exec="hoverTooltipEnabled ? viewTo : !$root.help ? viewTo : $root.trigger_help"  
        :execParam="hoverTooltipEnabled ? ['TableLayout'] : !$root.help ? ['TableLayout'] : ['switch_table']" 
        :hoverParam="'switch_table'"  
        :icnClasses="[activeView == 'TableLayout' ? ' active-view' : '', $root.icons.table, 'support-tool-icon']">  
      </dynIcon>

      <dynIcon 
        :configs="{ID: 'switch_img', visible: true}"   
        :exec="hoverTooltipEnabled ? viewTo : !$root.help ? viewTo : $root.trigger_help"  
        :execParam="hoverTooltipEnabled ? ['ImgLayout'] : !$root.help ? ['ImgLayout'] : ['switch_img']" 
        :hoverParam="'switch_img'"  
        :icnClasses="[activeView == 'ImgLayout' ? ' active-view' : '', $root.icons.image, 'support-tool-icon']">  
      </dynIcon>

      <dynIcon 
        :configs="{ID: 'switch_grid', visible: true}"   
        :exec="hoverTooltipEnabled ? viewTo : !$root.help ? viewTo : $root.trigger_help"  
        :execParam="hoverTooltipEnabled ? ['GridLayout'] : !$root.help ? ['GridLayout'] : ['switch_grid']" 
        :hoverParam="'switch_grid'"  
        :icnClasses="[activeView == 'GridLayout' ? ' active-view' : '', $root.icons.grid, 'support-tool-icon']"
        :styleObj="{'padding': '10px 0px 15px 0px', 'border-bottom': '1px solid #090c0f', 'box-shadow': 'rgb(80, 94, 101) 0px 1px 0px;'}">  
      </dynIcon>

      <!-- SUPPORT CONTENTS TRIGGER -->      
      <cfg cid="supportSidebar.anteprime" tag='div'>
        <dynIcon 
          :configs="{ID: 'support_anteprime', visible: true}"   
          :exec="hoverTooltipEnabled ? openTo : !$root.help ? openTo : $root.trigger_help"  
          :execParam="hoverTooltipEnabled ? ['Anteprime'] : !$root.help ? ['Anteprime'] : ['support_anteprime']" 
          :hoverParam="'support_anteprime'"  
          :icnClasses="[supportContent == 'Anteprime' ? ' active-content' : '', $root.icons.preview, 'support-tool-icon']"
          :styleObj="{'padding': '15px 0px 10px 0px'}">  
        </dynIcon>
      </cfg>

      <dynIcon 
        :configs="{ID: 'support_impiego', visible: true}"   
        :exec="hoverTooltipEnabled ? openTo : !$root.help ? openTo : $root.trigger_help"  
        :execParam="hoverTooltipEnabled ? ['Impiego'] : !$root.help ? ['Impiego'] : ['support_impiego']" 
        :hoverParam="'support_impiego'"  
        :icnClasses="[supportContent == 'Impiego' ? ' active-content' : '', $root.icons.use, 'support-tool-icon']">  
      </dynIcon>

      <dynIcon 
        v-if="!$Components['support_documenti'].hidden"
        :configs="{ID: 'support_documenti', visible: true}"   
        :exec="hoverTooltipEnabled ? openTo : !$root.help ? openTo : $root.trigger_help"  
        :execParam="hoverTooltipEnabled ? ['Documenti'] : !$root.help ? ['Documenti'] : ['support_documenti']" 
        :hoverParam="'support_documenti'"  
        :icnClasses="[supportContent == 'Documenti' ? ' active-content' : '', $root.icons.documents, 'support-tool-icon']"
        :styleObj="{'padding':'10px 0px 15px 0px', 'border-bottom':'1px solid #090c0f', 'box-shadow':'rgb(80, 94, 101) 0px 1px 0px'}">  
      </dynIcon>

      <dynIcon 
        :configs="{ID: 'show_print', visible: true}"   
        :exec="hoverTooltipEnabled ? openTo : !$root.help ? openTo : $root.trigger_help"  
        :execParam="hoverTooltipEnabled ? ['Stampa'] : !$root.help ? ['Stampa'] : ['show_print']" 
        :hoverParam="'show_print'"  
        :icnClasses="[supportContent == 'Stampa' ? ' active-content' : '', $root.icons.print, 'support-tool-icon']">  
      </dynIcon>

    </aside>
    
    <!-- Content Wrapper. Contains page content -->
    <!-- Con position: relative; permetto ai componenti absolute figli (in particolare alla DynTable della schermata Detail), di usare dei valori percentuali 
    applicati rispetto alla larghezza/altezza di questo componente, e non dell'intera finestra -->
    <div id="route-view-parent" class="content-wrapper resize-stop sup-resize-stop table-resize-stop" :class="[right ? 'mtree_right' : 'mtree_left']" 
      :style="[{'max-height': maxHeight},overrideMtree_left]" style="position: relative; transition: none; overflow-y: hidden;"> <!--:style="'max-height:' + maxHeight + ';'"-->
      <router-view :right="right" @togglesupport="handleSupportSidebar" @closesupport="noWrapperRoute"></router-view>
    </div>
    <!-- /.content-wrapper -->
    <span id="m-wrap">
    <modal-select></modal-select>
    </span>

    <single-modal @API="CriteriaModal = $event" :title="$Jed.firstUpperTranslate('warning')" :options="criteriaModalConfigs">
      <div class="modal-input">
        <label>{{this.criteriaModalConfigs.content}}</label>
      </div>
    </single-modal>  

    <alert @API="alertAPI = $event" 
      :message="alertOPT.message" 
      :type="alertOPT.type" 
      :closeModal="alertOPT.action">
    </alert>
    
    <confirm @API="confirmAPI = $event" 
      :message="confirmOPT.message" 
      :Ycallback="confirmOPT.Ycallback" 
      :Ncallback="confirmOPT.Ncallback" 
      :YtxtBtn="confirmOPT.YtxtBtn"
      :NtxtBtn="confirmOPT.NtxtBtn"
      :title="confirmOPT.title"
      :icon="confirmOPT.icon">
    </confirm>
    
    <div id="wrapper_overlay" class="help_mode_overlay"></div> 

  </div>
  <!-- ./wrapper -->
</template>
<script>
  import faker from "faker";
  import { mapState } from "vuex";
  import config from "../config";
  import Sidebar from "./Sidebar";
  import SupportSidebar from "./SupportSidebar";
  import ModalSelect from "./loader/ModalSelect";
  import Breadcrumb from "./tree/breadcrumb.vue";
  import "hideseek";
  import PopoverAlert from "./dynamic/popoverWrapper/Popover.vue";
  import HelpPopover from "./dynamic/HelpPopover.vue";
  import dynIcon from "./dynamic/DynIcon.vue";
  import Cfg from "./dynamic/ConfigurableComponent.vue";
  import PendingNotifications from "./others/PendingNotifications.vue"

  import Alert from "./dynamic/modalWrapper/Alert.vue"
  import Confirm from "./dynamic/modalWrapper/Confirm.vue"
  import SingleModal from "./dynamic/modalWrapper/SingleModal.vue"
  import TabModal from "./dynamic/modalWrapper/TabModal.vue"
  import InputW from './dynamic/inputWrapper/inputWrapper.vue'
  import Grid from "./dynamic/jqwGridWrapper/jqwGridWrapper.vue";

  import { eventBus } from "../eventbus.js";
  import utils from '../../utils/utilities.js'

  var vm;
 
  export default {
    name: "Dash",
    components: {
      Sidebar,
      SupportSidebar,
      ModalSelect,
      Breadcrumb,
      PopoverAlert,
      HelpPopover,
      dynIcon,
      Cfg,
      Alert,
      Confirm,
      TabModal,
      SingleModal,
      InputW,
      Grid,
      PendingNotifications
    },
    data: function() {
      var vm = this;
      return {
        showNotifications: false,
        alertAPI: null,
        alertOPT: { type: "", message: "", action: function(){}},
        confirmAPI: null,
        confirmOPT: { 
          message: "Conferma per continuare", 
          Ycallback: function(){console.log("ok")}, 
          Ncallback: function(){console.log("no")},
          YtxtBtn: 'yes',
          NtxtBtn: 'no',
          title: "attenzione",
          icon: "info"
        },
        showSupportSidebar: false,
        supportContent: "",
        activeView: "Detail",

        openSupportSidebar: false,
        // section: 'Dash',
        year: new Date().getFullYear(),
        classes: {
          fixed_layout: config.fixedLayout,
          hide_logo: config.hideLogoOnMobile
        },
        error: "",
        focus: null,
        maxHeight: "0px",
        right: (this.right = this.$Behaviors.side == "dx"),

        helpers: null,
        langFlag: this.$root.lang.flag,
        modalTabs: [{
            name: "generalData",
            text: vm.$Jed.firstUpperTranslate('user data'),
            onLeave: function(){
            },
            onEnter: function(){
            }
          },
          {
            name: "clientData",
            text: vm.$Jed.firstUpperTranslate('client data'),
            onLeave: function(){
            },
            onEnter: function(){
            }
          }
        ],
        start: null,
        userDataModalConfigs:{
          showCancelButton: false,
          showConfirmButton: false,
          id: 'userDataModal'
        },
        changePwdModalConfigs:{
          showCancelButton: false,
          showConfirmButton: true,
          closeAfterConfirm: false,
          onConfirm: function(){
            vm.matching = true;
            vm.exsisting = true;
            $("#existing").hide();
            $("#matching").hide();
            vm.$root
              .microservice({
                role: "authentication",
                cmd: "Login",
                params: {
                  user: vm.$root.token.idUtente,
                  pwd: vm.currentPassword,
                  caller: "VERIFYPWD"
                }
              })
              .then(
                response => {
                  if (response.body.data) {
                    //è verificata la corrispondenza utente-password attuale
                    if(vm.newPassword == vm.confirmNewPassword){
                      vm.$root
                        .microservice({
                          role: "authentication",
                          cmd: "UpdatePwd",
                          params: { 
                            userId: vm.$root.token.idUtente,
                            newpwd: vm.newPassword,
                          }
                        })
                        .then( response => {
                          if(response.body){
                              //console.log(response.body)
                              vm.$refs.ChangePwdModal.close()
                              vm.$root.simpleNotification("success", {
                                title: "", 
                                message: vm.$Jed.firstUpperTranslate(response.body.toString())
                              });

                          } else {
                            console.log("onConfirm new password - no response");
                          }
                        })
                    }else{
                      vm.matching = false;
                      $("#matching").show();
                    }
                  } else {
                    console.log("onConfirm new password - no response");
                    vm.existing = false;
                    $("#existing").show();
                  }
                },
                err => {
                  console.log("onConfirm new password - error", err);
                }
              );
          }
        },
        changeLogoModalConfigs:{
          showCancelButton: false,
          showConfirmButton: true,
          closeAfterConfirm: true,
          onConfirm: function(){
          }
        },
        removeLogoModalConfigs:{
          showCancelButton: false,
          showConfirmButton: true,
          closeAfterConfirm: true,
          onConfirm: function(){
            console.log('Logo rimosso')
          }
        },
        doLogoutModalConfigs:{
          showCancelButton: false,
          showConfirmButton: true,
          closeAfterConfirm: true,
          onConfirm: function(){
            vm.logoutFromApp();
          }
        },
        fatherDetailModalConfigs:{
          title:"",
          showCancelButton: false,
          showConfirmButton: false,
          id: 'fatherDetailModal'
        },
        /* fatherModalTabs: [{
            name: "DetailFather",
            text: vm.$Jed.firstUpperTranslate('detail'), 
            onLeave: function(){
            },
            onEnter: function(){
                vm.start = "DetailFather"
            }
          }, {
              name: "ValidityFather",
              text: vm.$Jed.firstUpperTranslate('validity'), 
              onLeave: function(){
              },
              onEnter: function(){
                  vm.start = "ValidityFather"
              }
          }, {
              name: "DocumentsFather",
              text: vm.$Jed.firstUpperTranslate('document',2), 
              onLeave: function(){
              },
              onEnter: function(){
                  vm.start = "DocumentsFather"
              }
          }, {
              name: "AttributesFather",
              text: vm.$Jed.firstUpperTranslate('attribute',2), 
              onLeave: function(){
              },
              onEnter: function(){
                  vm.start = "AttributesFather"
              }
          }
        ], */
        fatherModalInputConfigs:{
          type:{
            id:"type", 
            val: '',
            cod: ''
          },
          description:{
            id:"descrField",
            lbl: vm.$Jed.firstUpperTranslate('description'), 
            val: ''
          },
          feature:{
            id:"featureField",
            lbl: vm.$Jed.firstUpperTranslate('specification'),
            val: ''
          },
          position:{
            id:"pos",
            lbl: vm.$Jed.firstUpperTranslate('position'),
            val: ''
          },
          quantity:{
            id:"qty",
            lbl: vm.$Jed.firstUpperTranslate('qty'),
            val: ''
          },
          codSost:{
            id:"codSost",
            lbl: vm.$Jed.firstUpperTranslate('substitute code'),
            val: ''
          },
          not:{
            id:"not",
            lbl: vm.$Jed.firstUpperTranslate('note', 2), 
            val: ''
          },
          validity:{
            id:"val",
            lbl: vm.$Jed.firstUpperTranslate('validity'), 
            from: '',
            to: ''
          },
          documents:{
            id:"doc",
            lbl: vm.$Jed.firstUpperTranslate('document', 2)
          },
          attributes:{
            id:"attr",
            lbl: vm.$Jed.firstUpperTranslate('attribute', 2)
          }
          /* vers:{
            id:"vers",
            lbl:"Versione", 
            val: ''
          },
          rev:{
            id:"rev",
            lbl:"Revisione", 
            val: ''
          },
          codAlt:{
            id:"codAlt",
            lbl: 'Cod Alternativo'
            val: ''
          } */
        },
        attrListCfg: {
          ID: "attrTable",
          title: "AttributesTabModalFather",
          label_title: "",
          visible: true,
          columns: {
            configs:{
              name: {
                text: "name",
                position: 1,
                visible: true,
                editable: false,
                width: "40%",
                searchable: false,
                sorting: true,
                datafield: "name"
              },
              descr: {
                text: "description",
                position: 2,
                visible: true,
                editable: false,
                width: "60%",
                searchable: false,
                sorting: true,
                datafield: "descr"
              }
            }
          }
        },
        docListCfg: {
          ID: "docTable",
          title: "DocumentsTabModalFather",
          label_title: "",
          visible: true,
          columns: {
            configs:{
              thumb: {
                text: "thumbnail",
                position: 1,
                visible: true,
                editable: false,
                width: "25%",
                searchable: false,
                sorting: true,
                datafield: "thumbnail",
                tobecellsrenderered: function (data_row, row, columnfield, value, defaulthtml, columnproperties) {
                  return '<div><img style="margin-left: 50px; margin-right: 50px;" height="50" width="50" src="' + data_row.thumb + '"/></div>';
                }
              },
              icon: {
                text: "icon",
                position: 2,
                visible: true,
                editable: false,
                width: "25%",
                searchable: false,
                sorting: true,
                datafield: "icon"
              },
              descr: {
                text: "description",
                position: 3,
                visible: true,
                editable: false,
                width: "50%",
                searchable: false,
                sorting: true,
                datafield: "descr"
              }
            }
          }
        },
        valListCfg: {
          ID: "validityTable",
          title: "ValidityTabModalFather",
          label_title: "",
          visible: true,
          columns: {
            configs:{
              from: {
                text: "from",
                position: 1,
                visible: true,
                editable: false,
                width: "50%",
                searchable: false,
                sorting: true,
                datafield: "from"
              },
              to: {
                text: "to",
                position: 1,
                visible: true,
                editable: false,
                width: "50%",
                searchable: false,
                sorting: true,
                datafield: "to"
              }
            }
          }
        },
        attrList: [],
        docList: [],
        valList: [],
        options: {
          columnsresize: true,
          columnsreorder: true,
          rowsheight: 52,
          theme: "light",
          width: "100%",
          selectionmode: "none",
          pageable: true,
          showfilterrow: false,
          filterable: true,
          sortable: true,
          pageable: false,
          autoheight: false,
          height: 310,
          rowdetails: true,
          rowdetailstemplate: {
            rowdetails:
              "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
            rowdetailsheight: 250 /* ! 230 + 20 ! */
          },
          /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
          ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
          initrowdetails: "nested",
          rendered: null
        },
        valGridOptions:{
          columnsresize: true,
          columnsreorder: true,
          rowsheight: 25,
          theme: "light",
          width: "100%",
          selectionmode: "none",
          showfilterrow: false,
          filterable: true,
          sortable: true,
          pageable: false,
          autoheight: true,
          height: 100,
          rowdetails: true,
          rowdetailstemplate: {
            rowdetails:
              "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
            rowdetailsheight: 250 /* ! 230 + 20 ! */
          },
          /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
          ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
          initrowdetails: "nested",
          rendered: null,
          ready: function(){ //ordinamento tabella all'apertura
            //$('#WrapperGrid').jqxGrid('sortby', 'sor', 'asc');
          }
        },
        attrGridOptions:{
          columnsresize: true,
          columnsreorder: true,
          rowsheight: 50,
          theme: "light",
          width: "100%",
          selectionmode: "none",
          showfilterrow: false,
          filterable: true,
          sortable: true,
          pageable: false,
          autoheight: true,
          height: 100,
          rowdetails: true,
          rowdetailstemplate: {
            rowdetails:
              "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
            rowdetailsheight: 250 /* ! 230 + 20 ! */
          },
          /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
          ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
          initrowdetails: "nested",
          rendered: null,
          ready: function(){ //ordinamento tabella all'apertura
            //$('#WrapperGrid').jqxGrid('sortby', 'sor', 'asc');
          }
        },
        userInputConfigs:{
          username:{
            id: "userField",
            lbl: vm.$Jed.firstUpperTranslate('user'), 
            val: ''
          },
          fullname:{
            id: "namField",
            lbl: vm.$Jed.firstUpperTranslate('name')+' '+vm.$Jed.firstUpperTranslate('surname'), 
            val: ''
          },
          nomeGruppo:{
            id: "profileField",
            lbl: vm.$Jed.firstUpperTranslate('profile'), 
            val: ''
          },
          mail:{
            id: "mailField",
            lbl: vm.$Jed.firstUpperTranslate('email'), 
            val: '' 
          },
          lang:{
            id: "langField",
            lbl: vm.$Jed.firstUpperTranslate('language'),
            val: this.$root.lang.lang 
          },
          phone:{
            id: "phoneField",
            lbl: vm.$Jed.firstUpperTranslate('phone'),
            val: ''
          },
          ragSoc:{
            id: "ragsoc",
            lbl: vm.$Jed.firstUpperTranslate('business name'),
            val: '' 
          },
          codfis:{
            id:"codf",
            lbl: vm.$Jed.firstUpperTranslate('fiscal code'),
          },
          piva:{
            id:"pIva",
            lbl: vm.$Jed.firstUpperTranslate('vat number'),
          },
          sito:{
            id:"sito",
            lbl: vm.$Jed.firstUpperTranslate('site'),
          },
          nomeTit:{
            id:"nomeTit",
            lbl: vm.$Jed.firstUpperTranslate('owner name'),
          },
          contCli:{
            id:"contact",
            lbl: vm.$Jed.firstUpperTranslate('person contact'),
          },
          indCli:{
            id:"address",
            lbl: vm.$Jed.firstUpperTranslate('address'),
          },
          capCli:{
            id:"cap",
            lbl: vm.$Jed.firstUpperTranslate('postal code'),
          },
          provCli:{
            id:"prov",
            lbl: vm.$Jed.firstUpperTranslate('province'),
          },
          locCli:{
            id:"loc",
            lbl: vm.$Jed.firstUpperTranslate('place'),
          },
          nazCli:{
            id:"country",
            lbl: vm.$Jed.firstUpperTranslate('country'),
          },
          telCli:{
            id:"tel",
            lbl: vm.$Jed.firstUpperTranslate('phone'),
          },
          faxCli:{
            id:"fax",
            lbl: vm.$Jed.firstUpperTranslate('fax'),
          },
          cellCli:{
            id:"cell",
            lbl: vm.$Jed.firstUpperTranslate('mobile'),
          },
          emailServ:{
            id:"cliMail",
            lbl: vm.$Jed.firstUpperTranslate('email')
          }
        },
        pwdInputConfigs:{
          cur:{
            id: "curPwd",
            lbl: vm.$Jed.firstUpperTranslate('current password'), 
          },
          new:{
            id: "newPwd",
            lbl: vm.$Jed.firstUpperTranslate('new password'), 
          },
          ok:{
            id: "okNewPwd",
            lbl: vm.$Jed.firstUpperTranslate('confirm') + ' ' + vm.$Jed.translate('new password')
          }
        },
        criteriaModalConfigs:{
          content: '',
          showCancelButton: false,
          showConfirmButton: true,
          closeAfterConfirm: true
        },
        expandView: true,
        info_software: false,
        info_popup_content: 'Powered by Bookmark s.r.l. <br> <a href="http://www.bkm.it/" target="_blank">'+vm.$Jed.firstUpperTranslate('go to site')+'</a>',
        fullscreen: this.$root.icons.expand,
        help_mode: false,
        active: 'show_catalog_tree',

        emptyDetailData:{
          typ: false,
          des: false,
          spe: false,
          pos: false,
          qty: false,
          spi: false,
          not: false,
          val: false,
          doc: false,
          attr: false
        },
        mainSidebarOpened: this.$Behaviors.expanded,
        emptyUserData: {
          ragSoc: false,
          codfis: false,
          piva: false,
          sito: false,
          nomeTit: false,
          contCli: false,
          indCli: false,
          capCli: false,
          provCli: false,
          locCli: false,
          nazCli: false,
          telCli: false,
          faxCli: false,
          cellCli: false,
          emailServ: false
        },
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        matching: true,
        existing: true,
        fieldIDs: [],
        previousValues: null,
        notifIcon: vm.$root.token.categoriaCliente=='Distributore' ? '150px' : '115px',
        notifCount: 0,
        cartCount: vm.$root.shopCartData ? vm.$root.shopCartData.prodotti.length : 0,
        breadcrumb_nodes: Number,
        overrideMtree_left:{},
        sessionStorage: sessionStorage,
        hoverTooltipEnabled: sessionStorage.getItem('device') == 'desktop' && !vm.$Behaviors.showHelpModeIcon
      };
    },
    watch: {
      $route: function(){
        this.checkActive();
      }
    },
    mounted: function() {
      
      var vm = this;
      this.$nextTick(function(){
        var h =  $(window).height();
        if (vm != null) {
          vm.$root.WINDOW_HEIGHT = h;
          vm.setMaxHeight();
        }

        try {
          window.addEventListener('resize', ()=>{
            var w = $(window).width(); 
            if(w>1000){
              vm.breadcrumb_nodes = 4;
            }else{
              vm.breadcrumb_nodes = 2;
            }
          });
        } catch (err) {
          console.log(err)
        }

        // voglio un listener sugli attributi del router-view-container, così posso segnalare globalmente a tutte le griglie di ridisegnarsi 
        window.MutationObserver = window.MutationObserver
            || window.WebKitMutationObserver
            || window.MozMutationObserver;
        // Find the element that you want to "watch"
        var target = document.getElementById('route-view-parent')
        // create an observer instance
        var observer = new MutationObserver(function(mutations) {
            var do_emit = false;
            for(var i = 0; i < mutations.length; i++){
              if(mutations[i].type == "attributes"){
                do_emit = true;
                break;  
              }
            }
            if(do_emit) eventBus.$emit("containerResize")
        });
        // configuration of the observer:
        var conf = {
            attributes: true, // this is to watch for attribute changes.
            characterData: false,
            childList: false,
            subtree: false,
            attributeOldValue: false,
            characterDataOldValue: false
        };
        // pass in the element you wanna watch as well as the options
        observer.observe(target, conf);
        // later, you can stop observing
        // observer.disconnect();
        
        this.initHelpers();
      })

      if(this.$Components["sidebar.tree"] && this.$Components["sidebar.tree"].width){
        this.overrideMtree_left = {
          'margin-left': this.$Components["sidebar.tree"].width+'px'
        }
      }
    },
    created: function() {
      var vm = this;

      eventBus.$on("notificationLoop", function(length){
        vm.notifCount = length
        this.$nextTick(()=>{
          if(length<10){
            $('#notification_counter').css('width','15px')  
          }else if(length>10 && length<100){
            $('#notification_counter').css('width','19px')  
          }else{
            $('#notification_counter').css('width','24px')
          }
        })
      })

      eventBus.$on("cartFilled", function(length){
        vm.cartCount = length
      })

      eventBus.$on("alert", function(e){
        vm.alertOPT.message = e.message;
        vm.alertOPT.type = e.type;
        if(e.action){
          if(e.action == "logoutFromApp"){
            setTimeout(function(){
              vm.logoutFromApp();
            }, 4000);
          }
          vm.alertOPT.action = vm[e.action]
        }
        vm.alertAPI.open();
      })
      eventBus.$on("confirm", function(e){
        vm.confirmOPT.message = e.message;
        vm.confirmOPT.title = e.title;
        vm.confirmOPT.Ycallback = e.ok;
        vm.confirmOPT.Ncallback = e.no;
        vm.confirmOPT.YtxtBtn = e.YtxtBtn;
        vm.confirmOPT.NtxtBtn = e.NtxtBtn;
        vm.confirmOPT.icon = e.icon;
        vm.confirmAPI.open();
      })

      eventBus.$on("openFatherDetailModal", function(elem) {
        console.log(elem)
        var lid = vm.$root.token.siglaLingua,
            prod_type = vm.$root.prod_icons[elem.typ];
            
        vm.fatherDetailModalConfigs.title = '<i class="'+ prod_type.icn +'""></i>' + " " + elem.id + " - " + elem.des;

        vm.emptyDetailData.typ = false
        vm.emptyDetailData.des = false
        vm.emptyDetailData.spe = false
        vm.emptyDetailData.pos = false
        vm.emptyDetailData.qty = false
        vm.emptyDetailData.spi = false
        vm.emptyDetailData.not = false
        vm.emptyDetailData.val = false
        vm.emptyDetailData.doc = false
        vm.emptyDetailData.attr = false

        if(elem.typ){
          vm.fatherModalInputConfigs.type.val = prod_type.des[lid]
          vm.emptyDetailData.typ = false
        }else{
          vm.emptyDetailData.typ = true
        } 
        
        if(elem.id){
          vm.fatherModalInputConfigs.type.cod = elem.id 
        }

        if(elem.des){
          if(elem.des.length > 55){
            vm.fatherModalInputConfigs.description.rows = "3";
          }else{
            vm.fatherModalInputConfigs.description.rows = "1";
          }
          vm.fatherModalInputConfigs.description.val = elem.des;
        }else{
          vm.emptyDetailData.des = true;
        } 
        if(elem.spe){
          if(elem.spe.length > 60){
            vm.fatherModalInputConfigs.feature.rows = "3";
          }else{
            vm.fatherModalInputConfigs.feature.rows = "1";
          }
          vm.fatherModalInputConfigs.feature.val = elem.spe;
        }else{
          vm.emptyDetailData.spe = true;
        }

        if(elem.pos){
          vm.fatherModalInputConfigs.position.val = elem.pos 
          vm.emptyDetailData.pos = false
        }else{
          vm.emptyDetailData.pos = true
        } 

        if(elem.qty){
          vm.fatherModalInputConfigs.quantity.val = elem.qty 
          vm.emptyDetailData.qty = false
        }else{
          vm.emptyDetailData.qty = true
        } 

        if(elem.spi){
          vm.fatherModalInputConfigs.codSost.val = elem.spi 
          vm.emptyDetailData.spi = false
        }else{
          vm.emptyDetailData.spi = true
        } 

        if(elem.not && elem.not!=" "){ 
          vm.emptyDetailData.not = false
          if(elem.not.length > 60){
            vm.fatherModalInputConfigs.not.rows = "3";
          }else{
            vm.fatherModalInputConfigs.not.rows = "1";
          }
          vm.fatherModalInputConfigs.not.val = elem.not;  
        }else{
          vm.emptyDetailData.not = true
        }  

        vm.valList = [];
        for(var v in elem.val){
          var va = elem.val[v]
          vm.valList.push({
            'from': va.sv ? new Date(va.sv) ? new Date(va.sv).toLocaleDateString() : va.sv : '',
            'to': va.ev ? new Date(va.ev) ? new Date(va.ev).toLocaleDateString() : va.ev : '',
            }
          )
        }
        if(vm.valList.length==0){
          vm.emptyDetailData.val = true;
        }else{ 
          vm.emptyDetailData.val = false;
        }

        vm.docList = [];
        for(var d in elem.doc){
          var doc = elem.doc[d] 
          vm.docList.push({
            'thumb': doc.na, //path dell'immagine
            'icon': doc.icn, //html per l'icona, es.: <i class="fa fa-tags"></i>
            'descr': doc.le
            }
          )
        }
        if(vm.docList.length==0){
          vm.emptyDetailData.doc = true;
        }else{
          vm.emptyDetailData.doc = false;
        }

        vm.attrList = [];
        /* elem.att_o = [{
          "nam":{"ITA":'Questo è il nome dell\'attributo'},
          "des":{"ITA":'Questa è la descrizione dell\'attributo ed è un pò più lunga del nome'}
        }] */
        if(elem.att_o){  //elem.ota
          for(var i=0; i<elem.att_o.length; i++){
            var att = elem.att_o[i];
            vm.attrList.push({
              'name': att.nam[lid],
              'descr': att.des[lid]
            })
          }
        }

        if(vm.attrList.length==0){
          vm.emptyDetailData.attr = true;
        }else{
          vm.emptyDetailData.attr = false;
        }

        vm.start = "DetailFather";
        vm.FatherDetailModal.open();
      });

      eventBus.$on("item_clicked", item => {
        console.log("item_clicked: ", item);
        if (item.cco != null && item.cco != 0) {
          //se ha figli
          vm.$root.navigateTo(item.sid, item.fid);
        } else {
          //se è foglia
          vm.$router.push({
            name: "wrapper_focus",
            params: { id: vm.$root.encode(item.fid), focus: item[vm.$Behaviors.focusBy()] }
          });
        }
      });

      eventBus.$on("openSearchCriteriaModal", function(msg) {
        vm.criteriaModalConfigs.content = msg
        vm.CriteriaModal.open();
      });

      eventBus.$on("heightMutation", function(){
        vm.$nextTick(function(){
          vm.setMaxHeight();
        })
      });
      
      eventBus.$on("defaultView", function(view){
        vm.activeView = view
      });

      eventBus.$on("openSidebarDocumenti", function(){
        vm.openTo('Documenti')
        vm.openSupportSidebar = true;
      });
      
      eventBus.$on("closeSidebarDocumenti", function(){
        vm.openSupportSidebar = false;
        vm.supportContent = '';
      });

      eventBus.$on("searchUsesTree", function(e){
        vm.openImpieghi(e)
      })

      //gestione icona e flag quando esco da fullscreen premendo il tasto esc
      document.addEventListener('fullscreenchange', exitHandler);
      document.addEventListener('webkitfullscreenchange', exitHandler);
      document.addEventListener('mozfullscreenchange', exitHandler);
      document.addEventListener('MSFullscreenChange', exitHandler);

      function exitHandler() {
          if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
              vm.expandView = true;
              vm.fullscreen = vm.$root.icons.expand
          }
      }  
    },
    computed: {
      ...mapState(["userInfo"]),
      demo() {
        return {
          displayName: faker.name.findName(),
          avatar: faker.image.avatar(),
          email: faker.internet.email(),
          randomCard: faker.helpers.createCard()
        };
      },
      logoSrc(){
        var path = this.$root.front_end_configs.router_url + this.$Configs.licenseId+'/brand/'
        return this.$root.brandObj ? path + this.$root.brandObj.logo : ( localStorage.getItem('brand') ? path + JSON.parse(localStorage.getItem('brand')).logo : (this.$Configs.azienda.logo ? path + this.$Configs.azienda.logo : ''))
      }
    },
    methods: {
      doLogoutModal: function(){
        this.DoLogoutModal.open();
      },
      initHelpers: function(){
        var vm = this;
        setTimeout(function(){
          var logo_width = document.getElementById("logo_div").offsetWidth;

          vm.helpers = [
            {id: 'open_catalog', msg: 'load new catalog or sub-category', value: false, pos: {left: 52, top: 10, bottom: '', right: ''} },
            {id: 'show_catalog_tree', msg: 'show catalog navigation tree', value: false, pos: {left: 52, top: 40, bottom: '', right: ''} },
            {id: 'show_search', msg: 'show search panel', value: false, pos: {left: 52, top: 58, bottom: '', right: ''} },
            {id: 'show_cart', msg: 'show cart interface', value: false, pos: {left: 52, top: 65, bottom: '', right: ''} },
            {id: 'show_archive', msg: 'show archive interface', value: false, pos: {left: 52, top: 68, bottom: '', right: ''} },
            {id: 'show_preference', msg: 'show preferences interface', value: false, pos: {left: 52, top: 90, bottom: '', right: ''} },
          
            {id: 'manual_sync', msg: 'launch remote sync', value: false, pos: {left: 52, top: -10, bottom: 65, right: ''} },
            {id: 'show_info_sw', msg: 'show software info', value: false, pos: {left: 52, top: 60, bottom: '', right: ''} },
            
            {id: 'switch_detail', msg: 'view detail layout', value: false, pos: {leftOffset: 290, top: 57} },
            {id: 'switch_grid', msg: 'view grid layout', value: false, pos: {leftOffset: 250, top: 67} },
            {id: 'switch_table', msg: 'view table layout', value: false, pos: {leftOffset: 250, top: 60} },
            {id: 'switch_img', msg: 'view image layout', value: false, pos: {leftOffset: 250, top: 63} },
            
            {id: 'support_anteprime', msg: 'open preview', value: false, pos: {leftOffset: 280, top: 69} },
            {id: 'support_impiego', msg: 'open usage', value: false, pos: {leftOffset: 320, top: 69.1} },
            {id: 'support_documenti', msg: 'open attachments', value: false, pos: {leftOffset: 250, top: 70} },
            {id: 'show_print', msg: 'show print panel', value: false, pos: {leftOffset: 250, top: 70.1} },
          
            {id: 'notification', msg: 'notification list', value: false, pos: {leftOffset: 230, top: 40, bottom: ''} },
            {id: 'show_user_data', msg: 'show user data', value: false, pos: {leftOffset: 220, top: 40, bottom: ''} },
            {id: 'toggle_fullscreen', msg: 'fullscreen mode', value: false, pos: {leftOffset: 210, top: 40, bottom: ''} },
            {id: 'logout', msg: 'logout', value: false, pos: {leftOffset: 200, top: 40, bottom: ''} },
            {id: 'goto_distrib', msg: 'go to distrib', value: false, pos: {leftOffset: 190, top: 40, bottom: ''}},

            {id: 'toggle_support', msg: 'expand support sidebar', value: false, pos: {leftOffset: 250, top: '', bottom: ''} },
            {id: 'goto_brandsite', msg: 'go to brand site', value: false, pos: {left: 50, top: 5, bottom: ''} },
            {id: 'father_detail', msg: 'show father detail', value: false, pos: {left: (logo_width + 50), top: 49, bottom: ''} },
            {id:'total_quantity', msg: 'total quantity', value: false, pos: {leftOffset: 200, top: 62}}
          ]
          vm.$forceUpdate();
        }, 100)
      },
      printGateway: function(){
        var TODO = true
        if(!TODO){
          // Stampa avanzata modulo 
          //call mixin default, wathc active item
        } else {
          this.openTo('Stampa') 
        }
      },
      checkActive: function(){
        switch(this.$route.name){
          case "preferences":
            this.active = "show_preference"
            break;
          case "wrapper":
          case "wrapper_focus":
            if(this.active != "show_search"){
              this.active = "show_catalog_tree"
            }
            break;
          case "ShopCart":
            this.active = "show_cart"
            break;
          case "OrdersArch":
            this.active = "show_archive"
            break;
        }
      },
      viewTo: function(view){
        if(this.$root.showOnlyImg || this.$root.blockedGridView){
          return;
        }else{
          if(this.activeView != view){
            this.activeView = view;
            eventBus.$emit("changeView", view);
          }
        }
      },
      openTo: function(content){
        if(this.supportContent != content) {
          this.supportContent = content;
          this.openSupportSidebar = true;
        }else{
          this.openSupportSidebar = false;
          this.supportContent = '';
        }
      },
      openImpieghi: function(e){
        this.supportContent = "Impiego"
        this.openSupportSidebar = true;
        this.$root["richiestaImpiego"] = e;
        this.$root["richiestaImpiegoPerm"] = e;
      },
      handleSupportSidebar: function(show){
        this.openSupportSidebar = show;
        this.showSupportSidebar = true;
        if(!this.openSupportSidebar){
          if (!this.right) {
            $(".content-wrapper").css("margin-right", 50);
          } else {
            $(".content-wrapper").css("margin-left", 50);
          } 
        }
      },
      noWrapperRoute: function(){
        this.showSupportSidebar = false;
        this.openSupportSidebar = false;
        document.getElementById("route-view-parent").style["margin-right"] = "0px";
      },
      setMaxHeight: function() {
        if(this.$root.WINDOW_HEIGHT != null){
          this.maxHeight = this.$root.WINDOW_HEIGHT - 100 + "px";
        }
      },
      goToBrandSite: function() {
        var url = this.$root.brandObj ? this.$root.brandObj.url : (localStorage.getItem('brand') ? JSON.parse(localStorage.getItem('brand')).url : '')
        if(url){
          window.open(url, '_blank');
          //this.$root.manualSync();
        }else{
          location.reload();
        }
        //this.$root._SYNC_TEST_UNIT();
        // this.$root.manualSync();
      },
      changeloading() {
        this.$store.commit("TOGGLE_SEARCHING");
      },
      devPage: function(){
        this.$router.push({name: 'Dev'})
      },
      toggleNotification: function(){
        this.showNotifications = !this.showNotifications
        if(this.showNotifications){
          $('.nav_breadcrumb').css('cursor','context-menu'); //rendo il breadcrumb non cliccabile
          $(".underline").removeAttr("href"); 

          $("header > a").removeAttr('data-toggle'); //rendo l'icona che espande la sidebar non cliccabile
          $("header > a").css('cursor','context-menu');

          $('#wrapper_overlay').css('visibility','visible');
          document.getElementById("side-toolbar").style.setProperty('z-index', '9999', 'important');

          $('#extra-toolbar').css('z-index','9999');
          $('header.main-header').css('z-index','9999');
        }else{
          $('.nav_breadcrumb').css('cursor','pointer');
          $(".underline").attr("href", "#");

          $("header > a").attr('data-toggle', 'offcanvas');
          $("header > a").css('cursor','pointer');

          $("#logo_div").css('background-color','');
          $(".btn-default").css('background-color','');
          $(".btn-default").css('border-color','');

          //$('#'+this.active).css('color','rgb(255, 247, 139)')
          $('#wrapper_overlay').css('visibility','hidden');
          $('header.main-header').css('z-index','811');
          $('#side-toolbar').css('z-index','810');
          $('#extra-toolbar').css('z-index','810');
        }
        this.info_software = false
      },
      toggleHelpFlag: function() {
        this.help_mode = !this.help_mode;
        if(this.help_mode){
          $('#noOverlay').css('color','#fff78b');
          $('.nav_breadcrumb').css('cursor','context-menu'); //rendo il breadcrumb non cliccabile
          $(".underline").removeAttr("href"); 

          $("header > a").removeAttr('data-toggle'); //rendo l'icona che espande la sidebar non cliccabile
          $("header > a").css('cursor','context-menu');

          /*$("#logo_div").css('background-color','#666'); //imposto la non variazione del colore di sfondo all'hover sul logo
          $(".btn-default").css('background-color','#f4f4f4');
          $(".btn-default").css('border-color','#ddd');*/

          $('#wrapper_overlay').css('visibility','visible');
          document.getElementById("side-toolbar").style.setProperty('z-index', '9999', 'important');

          $('#extra-toolbar').css('z-index','9999');
          $('header.main-header').css('z-index','9999');
          this.help_mode = true;
          this.active = "toggle_help_flag";
        }else{
          $('#noOverlay').css('color','white');
          $('.nav_breadcrumb').css('cursor','pointer');
          $(".underline").attr("href", "#");

          $("header > a").attr('data-toggle', 'offcanvas');
          $("header > a").css('cursor','pointer');

          $("#logo_div").css('background-color','');
          $(".btn-default").css('background-color','');
          $(".btn-default").css('border-color','');

          //$('#'+this.active).css('color','rgb(255, 247, 139)')
          $('#wrapper_overlay').css('visibility','hidden');
          $('header.main-header').css('z-index','811');
          $('#side-toolbar').css('z-index','810');
          $('#extra-toolbar').css('z-index','810');
          this.active = null;
        }
        this.info_software = false
        this.$root.help = !this.$root.help;
      },
      toggleInfoSw: function() {
        this.info_software = !this.info_software;
        if(this.info_software){
          $('#wrapper_overlay').css('visibility','visible');
          $('#side-toolbar').css('z-index','9999');
          $('#extra-toolbar').css('z-index','9999');
          $('header.main-header').css('z-index','9999');
        } else {
          $('#wrapper_overlay').css('visibility','hidden');
          $('header.main-header').css('z-index','811');
          $('#side-toolbar').css('z-index','810');
          $('#extra-toolbar').css('z-index','810');
        }
      },
      showContent: function(id, action, route_name, event_name){
        console.log('showContent: ', id, action, route_name, event_name)
        //se sono nell'offline e il registry non è ancora stato caricato, impedisco l'accesso al carrello e all'archivio
        if(id == 'show_cart' || id == 'show_archive' || id == 'show_search'){
          if(this.$root.preferences.useOffline){
            var len = this.$root.dbServRegistry.collections.length != this.$root.front_end_configs.collectionsInServReg
            var len2 = this.$root.dbRegistry.collections.length != this.$root.front_end_configs.collectionsInIdb
            var cond = this.$root.dbServRegistry == null || this.$root.dbRegistry == null || len || len2
            console.log(cond)
            if(cond){
              eventBus.$emit('alert', {
                  message: this.$Jed.firstUpperTranslate('your data are loading. Try again in a few seconds.'), 
                  type: "warning" 
              })
              return;
            }
          }
        }

        if(id == 'show_cart'){
          if(this.$root.shopCartData == null){
            /* eventBus.$emit('alert', {
                message: this.$Jed.firstUpperTranslate('unable to start cart'), 
                type: "warning" 
            })
            return */
            if(!this.$Configs.ecp.ecidUrl){
                this.$root.newCart('start'); //se è stato passato il link e-commerce, non inizializzo il carrello
            }
            var tempId = this.$root.getTempReferenceId();
          }
        }
        // CATALOG 'show_catalog_tree', mainSidebarOpened ? 'close' : 'open', null, 'openSidebarMenu'

        if(!this.$root.BLOCK_NAVIGATION){
          if(id == 'show_catalog_tree' || id=="show_search"){
            if(this.active!=id){ //se il componente attuale, non è l'ultimo che era attivo
              this.$root.openSidebar();
              //imposto un flag che indica che la sidebar è aperta
              this.mainSidebarOpened = true
            }else{
              if(action == "open"){ //azione associata all'icona
                this.$root.openSidebar();
                //imposto un flag che indica che la sidebar è aperta
                this.mainSidebarOpened = true
              } else if(action == "close") {
                this.$root.closeSidebar();
                this.mainSidebarOpened = false
              }
            }
          }else{ //se il componente attuale non è l'apertura dell'albero o della ricerca, apri e chiudi la sidebar normalmente
            if(action == "open"){ //azione associata all'icona
                this.$root.openSidebar();
                //imposto un flag che indica che la sidebar è aperta
                this.mainSidebarOpened = true
              } else if(action == "close") {
                this.$root.closeSidebar();
                this.mainSidebarOpened = false
              }
          }
          if(id){
            this.active = id; //imposto come active il componente attuale
          }
          if(route_name){
            this.$router.push({name: route_name});
          }
          if(event_name){
            eventBus.$emit(event_name);
          }
        }
      },
      showUserData: function() {
        var vm = this;

        this.emptyUserData = {
          ragSoc: false,
          codfis: false,
          piva: false,
          sito: false,
          nomeTit: false,
          contCli: false,
          indCli: false,
          capCli: false,
          provCli: false,
          locCli: false,
          nazCli: false,
          telCli: false,
          faxCli: false,
          cellCli: false,
          emailServ: false
        }
        
        this.$root
          .microservice({
            role: "authentication",
            cmd: "GetUserClientInfo",
            params: {
              ute: this.$root.token.idUtente,
              cli: this.$root.token.idCliente
            }
          })
          .then(
            response => {
              if (response && response.body) {
                var clientDataFields = ['fullname', 'username', 'mail', 'nomeGruppo', 'phone', 'ragSoc', 'codfis', 'piva', 'sito', 'nomeTit', 'contCli', 'indCli', 'capCli', 'provCli', 'locCli', 'nazCli', 'telCli', 'faxCli', 'cellCli', 'emailServ']
                for(var i=0; i<clientDataFields.length; i++){
                  if(response.body[clientDataFields[i]]){
                    vm.userInputConfigs[clientDataFields[i]].val = response.body[clientDataFields[i]];
                    vm.emptyUserData[clientDataFields[i]] = false;
                  }else{
                    vm.emptyUserData[clientDataFields[i]] = true;
                  }
                }
                this.previousValues = {
                  'namField': vm.userInputConfigs['fullname'].val,
                  'userField': vm.userInputConfigs['username'].val,
                  'phoneField': vm.userInputConfigs['phone'].val,
                  'mailField': vm.userInputConfigs['mail'].val
                }
              } else {
                console.log("GetUserClientInfo - no response");
              }
            })
          .catch(err => {
            console.log(err);
            var msg = err && err.body && err.body.error ? err.body.error : ''
            vm.alertOPT.message = "Application caught an error <br> <h5>Details: " + "authentication.GetUserClientInfo - " + msg +'</h5>',
            vm.alertOPT.action = ""
            vm.alertAPI.open();
          })

        this.start="generalData";
        this.UserTabModal.open();
      },
      toggleFullScreen: function(){
        var doc = window.document;
        var docEl = doc.documentElement;

        var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
        var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
        
        if(this.expandView){
          this.fullscreen = this.$root.icons.compress
          this.expandView = false;
          if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
            requestFullScreen.call(docEl);
          }
        }else{
          this.fullscreen = this.$root.icons.expand
          this.expandView = true;
          cancelFullScreen.call(doc);
        }
      },
      logoutFromApp() {
        this.$root.logout();
      },
      enableEdit(id){
        var alreadyInArray = this.fieldIDs.includes(id)
        if(!alreadyInArray){
          this.fieldIDs.push(id);
        }
        document.getElementById(id).readOnly = false;

        document.getElementById(id).classList.add('edit');

        $('body').click(function(evt){ //rileva il click su tutto, cancella l'evento se clicco nei campi modificabili
          if(evt.target.id == "userField" || evt.target.id == "namField" || evt.target.id == "mailField" || evt.target.id == "phoneField" || evt.target.id == "editField"){
            return;
          }else{
            //se non ho cliccato su uno dei tre campi, rimuovo la classe e resetto il campo a non modificabile
            document.getElementById(id).classList.remove('edit');
            document.getElementById(id).readOnly = true;
          }
        });
      },
      saveChanges(){
        var values = [],
          vm = this;
        if(this.fieldIDs.length>0){
          for(var i = 0; i < this.fieldIDs.length; i++){
            if(this.previousValues[this.fieldIDs[i]] != document.getElementById(this.fieldIDs[i]).value){
              values.push({
                id: this.fieldIDs[i],
                val: document.getElementById(this.fieldIDs[i]).value
              })
            }
          }
          this.fieldIDs = [];
          this.$root
            .microservice({
              role: "authentication",
              cmd: "ChangeUserData",
              params: {
                ute: this.$root.token.idUtente,
                values: values
              }
            })
            .then(
              response => {
                if (response.body) {
                  var result = response.body.answer
                  for(var i=0;i<result.length;i++){
                    if(result[i].field=='fullname'){
                      if(result[i].val=='not updated'){
                        this.$root.simpleNotification("error", {
                          title: this.$Jed.firstUpperTranslate("data not modified"),
                          message: this.$Jed.firstUpperTranslate("user name must contain at least 5 letters") 
                        });
                      }else{
                        this.$root.simpleNotification("success", {
                          title: "", 
                          message: this.$Jed.firstUpperTranslate("user name has been modified correctly") 
                        });
                      }
                    }
                    if(result[i].field=='phone'){
                      if(result[i].val=='not updated'){
                        this.$root.simpleNotification("error", {
                          title: this.$Jed.firstUpperTranslate("data not modified"),
                          message: this.$Jed.firstUpperTranslate("phone number must contain at least 5 digits") 
                        });
                      }else{
                        this.$root.simpleNotification("success", {
                          title: "", 
                          message: this.$Jed.firstUpperTranslate("phone number has been modified correctly") 
                        });
                      }
                    }
                    if(result[i].field=='email'){
                      if(result[i].val=='not updated'){
                        this.$root.simpleNotification("error", {
                          title: this.$Jed.firstUpperTranslate("data not modified"),
                          message: this.$Jed.firstUpperTranslate("email address is badly formatted") 
                        });
                      }else if(result[i].val=='already used'){
                        this.$root.simpleNotification("error", {
                          title: this.$Jed.firstUpperTranslate("data not modified"),
                          message: this.$Jed.firstUpperTranslate("email address is already used by other user") 
                        });
                      }else{
                        this.$root.simpleNotification("success", {
                          title: "", 
                          message: this.$Jed.firstUpperTranslate("email address has been modified correctly") 
                        });
                      }
                    }
                  }
                } else {
                  console.log("ChangeUserData - no response");
                  this.$root.simpleNotification("error", {
                    title: this.$Jed.firstUpperTranslate("data not modified"),
                    message: this.$Jed.firstUpperTranslate("retry later or contact admin if the problem persists") 
                  });
                }
              }
            )
            .catch(err => {
              console.log(err);
              var msg = err && err.body && err.body.error ? err.body.error : ''
              vm.alertOPT.message = "Application caught an error <br> <h5>Details: " + "authentication.ChangeUserData - " + msg +'</h5>',
              vm.alertOPT.action = ""
              vm.alertAPI.open();
            })
          values = []
        }
      },
      goToDistrib(){
        var url = this.$root.front_end_configs.resellerInterfaceUrl+'/?CMD=LOGIN&token=' + localStorage.getItem("token")+'&lang='+this.$Configs.siglaLingua;
        var win = window.open(url, '_blank');
        win.focus();
      },
      showUserManual(){
        window.open(this.$root.msPath + '/'+ this.$Configs.licenseId +'/doc/src/manuale_utente_'+this.$Configs.idLingua+'.pdf');
      }
    }
  };
</script>
<style  lang="scss">
  .main-header .sidebar-toggle{
    padding: 17.5px 17px;
  }
  .wrapper.fixed_layout {
    .main-header {
      position: fixed;
      width: 100%;
    }
    .content-wrapper {
      padding-top: 50px;
    }
    .main-sidebar {
      position: fixed;
      height: 100vh;
    }
  }

  .wrapper.hide_logo {
    @media (max-width: 767px) {
      .main-header .logo {
        display: none;
      }
    }
  }

  .logo-mini,
  .logo-lg {
    text-align: left;
    img {
      padding: 0.4em !important;
    }
  }

  .logo-lg {
    img {
      display: -webkit-inline-box;
      width: 25%;
    }
  }

  .user-panel {
    height: 4em;
  }

  .user-menu li > a {
    padding: 7px 10px;
  }

  .user-menu ul {
    padding: 0px !important;
    border-width: 1px;
    border-color: #e1e3e9;
  }

  hr.visible-xs-block {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.17);
    height: 1px;
    border-color: transparent;
  }

  .logoutDD {
    color: #444444 !important;
  }

  .sidebar-menu > li > a {
    padding: 12px 15px 12px 15px;
  }

  .sidebar-menu li.active > a > .fa-angle-left,
  .sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
    animation-name: rotate;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-90deg);
    }
  }

  .ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .sidebar-collapse .hide-collapse {
    visibility: collapse;
  }

  .sidebar-collapse .content-wrapper.mtree_right,
  .sidebar-collapse .main-footer.mtree_right {
    margin-left: 50px;
  }

  .w-fixed-right {
    width: 270px !important;
  }
  .m-fixed-right {
    margin-left: 270px !important;
  }

  .sidebar-collapse .content-wrapper.mtree_left,
  .sidebar-collapse .main-footer.mtree_left {
    margin-left: 50px !important;
  }

  .sidebar-collapse .mtree_right {
    margin-right: 50px !important;
  }
  .sidebar-collapse .wtree_right.maintree {
    width: 50px !important;
  }

  @media (min-width: 768px) {
    .wtree_left {
      width: 350px;
    }
    .wtree_right {
      width: 350px;
    }
    .mtree_left {
      margin-left: 350px;
      margin-right: 0px;
    }
    .mtree_right {
      margin-left: 50px;
      margin-right: 350px;
    }
  }

  .sweet-modal .sweet-box-actions .sweet-action-close {
    display: table !important;
    cursor: pointer !important;
    color: white !important;
    text-align: center !important;
    width: 0px !important;
    height: 0px !important;
    line-height: 0px !important;
    border-radius: 50% !important;
    &:hover {
      background: none !important;
      color: none !important;
    }
  }

  #userDataModal .sweet-action-close {
    display: table !important;
    cursor: pointer !important;
    color: #555 !important;
    text-align: center !important;
    width: 0px !important;
    height: 0px !important;
    line-height: 0px !important;
    border-radius: 50% !important;
    &:hover {
      background: none !important;
      color: none !important;
    }
  }

  .sweet-modal.is-visible .sweet-buttons,
  .sweet-modal.is-visible .sweet-content {
    transform: none;
    opacity: 1;
    /*padding-bottom: 10px !important;
    padding-top: 10px !important;*/
  }

  .navbar-icon-right{
    color: white;
    font-size: 24px;
    margin-right: 8px;
  }

  .sweet-modal ul.sweet-modal-tabs li.sweet-modal-tab.active a {
    font-weight: 600;
    color: #039be5 !important;
  }

  .sweet-modal ul.sweet-modal-tabs li.sweet-modal-tab a {
    color: #222c38 !important;
  }

  .sweet-modal.sweet-alert .sweet-content {
    font-size: 14px !important;
  }

  label {
    font-weight: 550 !important;
  }

  .formSmallerInput {
    width: 50%;
    margin-left: 73px;
  }

  .twoColForm {
    width: 50%;
    float: left;
  }

  #tabgeneralData, #tabclientData, #tabDetail, #tabDocuments, #tabValidity, #tabInfos, #tabAttributes{
    color: #337ab7 !important;
  }

  #tabgeneralData:hover, #tabclientData:hover, #tabDetail:hover, #tabDocuments:hover, #tabValidity:hover, #tabInfos:hover, #tabAttributes:hover{
    color: #555 !important;
    background: rgba(247, 247, 247, 1);
  }

  li.active > a#tabgeneralData, li.active > a#tabclientData, li.active > a#tabDetail, li.active > a#tabDocuments, li.active > a#tabValidity, li.active > a#tabInfos, li.active > a#tabAttributes {
    color: #555 !important;
    background: rgba(0,0,0,0);
    border-bottom-color: transparent;
  }

  .sweet-modal .user-modal-data{
    height: 300px; 
    overflow-y: scroll;
  }

  @media (max-height: 550px){ //as long as the screen height is under 550px, the modal is smaller and scrollable
    .sweet-modal .user-modal-data{
      height: 125px; 
      overflow-y: scroll;
    }
  }

  .tab-general > .modal-body{
    padding-top: 5%;
  }

  .modal-input{
    margin-right: 0px !important; 
    margin-left: 10px !important; 
    margin-top: 10px !important; 
    margin-bottom: 10px !important;
  }


</style>
<style scoped>

  .edit{
    border-color: #57b4ea;
    box-shadow: #9bcdea 1px 1px 10px;
  }

  .combined-icon{
    position: relative;
    display: inline-block;
    width: 2em;
    height: 3.3em;
    line-height: 4em;
    vertical-align: middle;
    cursor: pointer;
  }

  .combined-icon-2x{
    font-size: 2em;
    position: absolute;
    left: 0;
  }

  .combined-icon-1x{
    font-size: 1.2em;
    position: relative;
    color: #222d32;
    top: 15%;
    left: 3%;
  }

  aside.toolbar > div > i {
    cursor: pointer;
    margin-left: 0px !important;
  }

  .support-tool-icon {
    padding: 10px 0px; 
    color: #94A1A6; 
    display:block;
  }

  .side-right {
    margin-left: 0px !important;
    margin-right: 50px;
  }
  .side-left {
    margin-left: 50px !important;
    margin-right: 0px;
  }

  .right_fix {
    left: auto;
    right: 0px;
    height: 100%;
  }

  #side-shadow {
    -webkit-transition: null;
    -moz-transition: null;
    transition: null;
  }

  .help_mode_overlay{
    visibility: hidden; 
    background-color: #0a101985; 
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9001;
    font-size: 14px;
    -webkit-font-smoothing: antialiased; 
    background: rgba(#fff, 0.9); 
    opacity: 1; 
    transition: opacity 0.3s; 
    transform: translate3D(0, 0, 0); 
    -webkit-perspective: 500px;
  }

  /* i.active {
    color: #fff78b !important;
  } */

  #side-shadow, #extra-toolbar {
    height: calc(100% - 55px);
    border-bottom: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dash.vue?11a4d998